import React from "react";
import Loader from "react-js-loader";

function CardLoader() {
  return (
    <div className="loader-cus">
      <Loader
        type="spinner-circle"
        bgColor={"#fff"}
        color={"#fff"}
        size={100}
      />
    </div>
  );
}

export default CardLoader;
